const isLive = window.location.protocol === 'https:'
export const BASE_URL = isLive ? 'https://api.draivatar.com/Admin/api' : 'http://192.168.0.53:6002/Admin/api'
export const IMAGE_URL = isLive ? 'https://api.draivatar.com/' : 'http://192.168.0.53:6002/'
export const TOKEN = localStorage.getItem('token');

// ==========END-POINTS============
export const SignUp = '/sign-up'
export const LOGIN = '/login'
export const OTP = '/sendOtp'
export const checkOpt = '/checkOtp'
export const RESET_PASSWORD = '/set-new-password'
export const FORGOT_PASSWORD = '/forgot-password'
export const GET_PROFILE = '/view-profile'
export const CHANGE_PASSWORD = '/change-password'
export const LOGOUT = '/logout'

export const CREATE_USERS = '/create-user'
export const GET_SINGLE_USER = '/get-user'
export const EDIT_USER = '/edit-user'
export const DELETE_USER = '/delete-user'
export const GET_HYGEN_CALL_HISTORY = '/get-hygen-call-history'
export const CALL_RATE = '/call-rate'
export const CMS_CONTENT = '/cms'
export const SEND_INVOICE = '/send-invoice'
export const MARK_INVOICE_PAID = '/mark-invoice-paid'

export const EDIT_PROFILE = '/update-profile'
export const CREATE_CONTENT_HOMEPAGE = '/edit-single-page-data'
export const GET_SINGLEPAGE_DATA = '/single-page-data'
export const POST_UPLOADIMAGE = '/upload-image'
export const PATIENTPROFILE = '/get-user'
export const CHECKSECURITYCODE = '/check-security-code'
export const VEIWPROFILE = '/view-profile'
export const PATIENTRECORD = '/get-patient-records'
export const GET_CONSULTATION_LISTING = '/get-consultations'
export const GET_CONSULTATION_CHAT = '/get-consultation-chat'
export const EDIT_CONSULTATION_CHAT = '/edit-consultation-chat'
export const UPDATE_CONSULTATION_CHAT = '/update-consultation'
export const GET_PATIENT_CONSULTATIONS = '/get-patient-consultation'
export const UPLOAD_LAB_RESULTS = '/upload-lab-result'
export const GET_LAB_RESULTS = '/get-lab-result'
export const PROFILE = '/view-profile';
export const DELETE_LAB_RESULT = '/delete-lab-result';
export const ADD_DOCTOR = '/add-doctor';
export const EDIT_DOCTOR = '/edit-doctor';
export const DELETE_DOCTOR = '/delete-doctor';
export const GET_DOCTOR_LIST = '/get-doctors-list';

export const GET_REFERRAL_LIST = '/get-diagnosed-patients';
export const SEND_DIAGNOSTICS = '/send-diagnostics';
export const REFER_PATIENT = '/refer-patient';

export const REGISTER_CENTER = '/register-center';
export const UPDATE_CENTER = '/update-center';
export const GET_CENTER = '/get-center';

export const REGISTER_TEST = '/register-test';
export const UPDATE_TEST = '/update-test';
export const GET_TEST = '/get-test';
export const GET_ALL_TEST = '/get-all-test';

export const GET_PATIENTS = '/get-patients';
export const GET_CONSULTATION_OF_PATIENT = '/get-patient-consultations';
export const ADD_PRESCRIPTION = '/add-prescription';
export const GET_TRANSACTIONS = '/transactions';
